module.exports = __webpack_public_path__ + "img/footprints - merryPippin.c1951013.svg";